import { LOGOUT } from '@app/actions/user';
import { reducer as formReducer } from 'redux-form';

const ORDERS_INCOMING = '@ORDERS/INCOMING';
const ORDERS_ONGOING = '@ORDERS/ONGOING';

export default formReducer.plugin({
  'admin/changeOpeningTimes': (state, action) => {
    switch (action.type) {
      case LOGOUT:
        return undefined;
      default:
        return state;
    }
  },
  'admin/changeBottlePrice': (state, action) => {
    switch (action.type) {
      case LOGOUT:
        return undefined;
      default:
        return state;
    }
  },
});

const getIncomingOrdersDropdownValue = state =>
  state.form[ORDERS_INCOMING] ? state.form[ORDERS_INCOMING].values.orderType.value : null;

const getOngoingOrdersDropdownValue = state =>
  state.form[ORDERS_ONGOING] ? state.form[ORDERS_ONGOING].values.orderType.value : null;

export { getIncomingOrdersDropdownValue, getOngoingOrdersDropdownValue };



// WEBPACK FOOTER //
// ./src/reducer/form.js